import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6490d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "station-form-category-title"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-checked", "disabled", "data-testid", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "coverage-lock-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-testid": "coverage-mode-lock-icon"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["aria-checked", "disabled", "data-testid", "onClick"]
const _hoisted_8 = { class: "flex items-center justify-between gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "coverage-lock-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-testid": "coverage-mode-lock-icon"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = { class: "block text-xs text-[#68688D] mt-1" }
const _hoisted_12 = { class: "flex items-center gap-1.5 font-bold text-textPrimary" }
const _hoisted_13 = {
  class: "coverage-lock-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_14 = ["d"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-[#3E3E5A]" }, " Para marcar plantões cobertos por equipe da unidade, servidor ou outra empresa sem indicar o médico, a opção precisa estar ligada na configuração da escala. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-1 text-xs text-[#68688D]",
  "data-testid": "coverage-mode-locked-steps"
}, " Gerenciar escala → Editar escala → Informações básicas → ligar 'Permite plantão ocupado sem identificação' ", -1))
const _hoisted_17 = {
  key: 1,
  class: "mt-2 text-xs font-semibold text-[#3E3E5A]"
}
const _hoisted_18 = {
  key: 4,
  class: "text-xs text-[#68688D]",
  "data-testid": "coverage-mode-unidentified-hint"
}

import { computed, ref, watch } from 'vue'
import { mdiLock } from '@mdi/js'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import { COVERAGE_MODE_LABELS } from '@/utils/coverage'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageModeSelector',
  props: {
    modelValue: {},
    allowUnidentified: { type: Boolean },
    options: { default: () => [CoverageMode.DOCTOR, CoverageMode.UNIDENTIFIED, CoverageMode.OPEN] },
    variant: { default: 'segmented' },
    label: { default: 'Cobertura do plantão' },
    disabled: { type: Boolean, default: false },
    unidentifiedLocked: { type: Boolean, default: false },
    canOpenScheduleSettings: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "openScheduleSettings"],
  setup(__props: any, { emit }) {

const props = __props;





const CARD_TITLES: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]: 'Médico',
  [CoverageMode.UNIDENTIFIED]: 'Ocupado sem identificação',
  [CoverageMode.OPEN]: 'Vaga aberta'
}
const CARD_DESCRIPTIONS: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]: 'Um médico cadastrado cobre o plantão.',
  [CoverageMode.UNIDENTIFIED]: 'Já está coberto por terceiro. Não é vaga e nada é pago.',
  [CoverageMode.OPEN]: 'Precisa de médico. Entra nas métricas e nas ações de vaga.'
}
const CARD_BADGES: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]: 'Com médico',
  [CoverageMode.UNIDENTIFIED]: 'Ocupado',
  [CoverageMode.OPEN]: 'Aberta'
}
const CARD_BADGE_CLASSES: Record<CoverageMode, string> = {
  [CoverageMode.DOCTOR]: 'bg-primary5 text-primary40',
  [CoverageMode.UNIDENTIFIED]: 'coverage-badge-unidentified text-[#3E3E5A]',
  [CoverageMode.OPEN]: 'bg-[var(--st-open-bg,#FFEDD5)] text-[color:var(--st-open-text,#F18F1B)]'
}

const visibleOptions = computed(() =>
  props.options.filter((option) => option !== CoverageMode.UNIDENTIFIED || props.allowUnidentified)
)
const isLocked = (option: CoverageMode) =>
  option === CoverageMode.UNIDENTIFIED && !props.allowUnidentified && props.unidentifiedLocked
// Renderizadas = selecionáveis + a desativada (visível, mas nunca selecionada).
const renderedOptions = computed(() =>
  props.options.filter((option) => visibleOptions.value.includes(option) || isLocked(option))
)

const lockInfoId = `coverage-locked-info-${Math.random().toString(36).slice(2, 10)}`
const hovering = ref(false)
const focused = ref(false)
const pinned = ref(false)
const lockInfoOpen = computed(() => hovering.value || focused.value || pinned.value)

function closeLockInfo() {
  hovering.value = false
  focused.value = false
  pinned.value = false
}
function onHoverEnd() {
  hovering.value = false
}
function onFocusOut(event: FocusEvent) {
  const next = event.relatedTarget as Node | null
  const root = event.currentTarget as HTMLElement | null
  if (next && root?.contains(next)) return
  focused.value = false
  pinned.value = false
}

// `aria-disabled` (não `disabled`): o segmento continua focável e o aviso abre pelo teclado.
const lockedAttrs = (option: CoverageMode) =>
  isLocked(option)
    ? {
        'aria-disabled': 'true' as const,
        'aria-describedby': lockInfoOpen.value ? lockInfoId : undefined
      }
    : {}
const lockedListeners = (option: CoverageMode) =>
  isLocked(option)
    ? {
        mouseenter: () => (hovering.value = true),
        focus: () => (focused.value = true),
        keydown: (event: KeyboardEvent) => {
          if (event.key === 'Escape') closeLockInfo()
        }
      }
    : {}

function select(option: CoverageMode) {
  if (isLocked(option)) {
    pinned.value = !pinned.value
    if (!pinned.value) closeLockInfo()
    return
  }
  if (props.disabled || option === props.modelValue) return
  emit('update:modelValue', option)
}

// Troca de escala (ou flag desligada) com "Ocupado" marcado: volta para o que é permitido.
watch(
  visibleOptions,
  (options) => {
    if (options.length && !options.includes(props.modelValue)) emit('update:modelValue', options[0])
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-2 text-left",
    "data-testid": "coverage-mode-selector",
    onMouseleave: onHoverEnd,
    onFocusout: onFocusOut
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.variant === 'segmented')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          role: "radiogroup",
          "aria-label": _ctx.label,
          class: "flex w-full rounded-lg border border-solid border-gray-300 overflow-hidden"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderedOptions.value, (option) => {
            return (_openBlock(), _createElementBlock("button", _mergeProps({
              key: option,
              type: "button",
              role: "radio",
              "aria-checked": _ctx.modelValue === option,
              disabled: _ctx.disabled
            }, lockedAttrs(option), {
              "data-testid": `coverage-mode-option-${option.toLowerCase()}`,
              class: ["flex-1 px-3 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60", 
          isLocked(option)
            ? 'coverage-option-locked inline-flex items-center justify-center gap-1.5'
            : _ctx.modelValue === option
              ? 'bg-primary text-white'
              : 'bg-white text-textPrimary hover:bg-primary5'
        ]
            }, _toHandlers(lockedListeners(option), true), {
              onClick: ($event: any) => (select(option))
            }), [
              (isLocked(option))
                ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                    _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_unref(COVERAGE_MODE_LABELS)[option]), 1)
            ], 16, _hoisted_3))
          }), 128))
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          role: "radiogroup",
          "aria-label": _ctx.label,
          class: "grid grid-cols-1 md:grid-cols-2 gap-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderedOptions.value, (option) => {
            return (_openBlock(), _createElementBlock("button", _mergeProps({
              key: option,
              type: "button",
              role: "radio",
              "aria-checked": _ctx.modelValue === option,
              disabled: _ctx.disabled
            }, lockedAttrs(option), {
              "data-testid": `coverage-mode-option-${option.toLowerCase()}`,
              class: ["rounded-lg border border-solid p-3 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-60", 
          isLocked(option)
            ? 'coverage-option-locked border-lightGray30'
            : _ctx.modelValue === option
              ? 'border-primary bg-primary5'
              : 'border-lightGray30 bg-white'
        ]
            }, _toHandlers(lockedListeners(option), true), {
              onClick: ($event: any) => (select(option))
            }), [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center gap-1.5 font-bold text-sm", isLocked(option) ? '' : 'text-textPrimary'])
                }, [
                  (isLocked(option))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                        _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(CARD_TITLES[option]), 1)
                ], 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-xs rounded px-2 py-0.5", CARD_BADGE_CLASSES[option]])
                }, _toDisplayString(CARD_BADGES[option]), 3)
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(CARD_DESCRIPTIONS[option]), 1)
            ], 16, _hoisted_7))
          }), 128))
        ], 8, _hoisted_6)),
    (lockInfoOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          id: lockInfoId,
          role: "tooltip",
          class: "coverage-locked-info rounded-lg px-3 py-2 text-sm",
          "data-testid": "coverage-mode-unidentified-locked-info",
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (hovering.value = true))
        }, [
          _createElementVNode("p", _hoisted_12, [
            (_openBlock(), _createElementBlock("svg", _hoisted_13, [
              _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_14)
            ])),
            _createTextVNode(" Opção desativada nesta escala ")
          ]),
          _hoisted_15,
          _hoisted_16,
          (_ctx.canOpenScheduleSettings)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "mt-2 text-sm font-bold text-primary30 underline",
                "data-testid": "coverage-mode-open-schedule-settings",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openScheduleSettings')))
              }, " Abrir configuração da escala "))
            : (_openBlock(), _createElementBlock("p", _hoisted_17, " Peça a quem administra a escala para ligar. "))
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.variant === 'segmented' && _ctx.modelValue === _unref(CoverageMode).UNIDENTIFIED)
      ? (_openBlock(), _createElementBlock("p", _hoisted_18, " Sem médico no plantão: não há check-in, Registro de Atividade, pós-plantão nem pagamento. Formação, \"Médico escalado por\" e a checagem de horas consecutivas não se aplicam. "))
      : _createCommentVNode("", true)
  ], 32))
}
}

})